import React, {Component} from 'react'
import Header from "../components/header"
import Footer from "../components/footer"
import '../../static/css/style.scss'
import CardItem from "../components/cardItem"
class Japan extends Component {
	state={
		youshi:[
			{
				name:'走得“容易”',
				content:'日本有一个庞大的招收100万留学生的计划，在这个大前提下，去日本留学潜力大，担保手续，日语水平，文化程度等诸多方面的要求都不是“过高”这无形提高了签证率，因此“去”相对容易很多。',
			},
			{
				name:'钱花得“少”',
				content:'日本留学的费用比去其他国家少很多。去日本留学全免学费的比例大，国立大学约有90%的留学生全免，公立大学约在50%，私立大学也有部分优秀生全免学费。<br><br>' +
					'另外，日本奖学金的种类多、渠道多，仅政府、财团、民间提供的奖学金就达245项（不包括大学本身），日本政府还为留学生提供助学贷款政策。在某种意义上说，日本是工薪阶层子女留学的天堂。',
			},
			{
				name:'考取的方式“多”',
				content:'日本考大学的方式多选择的余地大，留日学生可以根据自己的水平、特长、喜好选择大学。多样化的考试对那些偏科和大考心态不平稳易失误的学生，提供了成功的机会。<br><br>' +
					'日本留学生统一考试，考分是算原始分，一分算一分，对有特长的学生可以充分发挥自己不同的特长，而国内高考标准分的算法对不少人是不利的。',
			},
			{
				name:'打工挣得“多”',
				content:'一方面在日本打工的机会比许多国家多，特别是2000年日本政府开始清理非法滞留者，客观上为留学生提供了更多的打工机会。另一方面，打工时给约在700～1000日元左右，也比不少国家多。',
			},
			{
				name:'受到教育的质量“高”',
				content:'一方面日本实行学分教育，可以使学习的弹性更大、选择性更大素质教育效果更好。另一方面，日本教育管理比西方国家更严格，比较适合中国学生长期形成的管理习惯，而且日本是世界第二大经济强国，可以接触到世界最新、最高水平的东西学生提高肯定快。',
			},
			{
				name:'毕业后就业氛围条件“好”',
				content:'现在日本经济滑坡，有不少家长担心。但是我们可以回头看一下，日本经济危机中的1998年日本大学毕业生就业率在87%左右，而且日本政府对留学生在日本就业持支持态度，就职签证比较容易（专业不对口也发放就职签证）。',
			},
			{
				name:'家长更“放心”',
				content:'日本是世界上最安全的国家之一，不像美国时不时的响起校园枪声，排斥甚至杀害外国人，而且日本是传统上比较正统的国家，也不像在西方和俄罗斯留学，生活上存在太大的随意性。' +
					'另外，日本的国民健康保险对留学生很有利，保险内诊治医疗费个人仅负担6%。当然日本清洁卫生，生病机率较小。',
			},
			{
				name:'在生活等方面更“方便”',
				content:'日本的地理位置、气候条件、生活方式、风土人情文化差异等方面与青岛相差不太大，而且距离也近，坐飞机甚至比日本国内的某些航线还近。日本国内交通方便，电气化铁路，四通八达，日本超市林立，商品齐全，选择余地大，还有不少24小时便利店，生活十分方便。',
			}
		],
		zhuanye:[
			{
				title:'电子',
				content:'专业概况：日本是世界上公认的电子王国，掌握着电子行业大部分核心技术，由于日本电器厂商不断研发新技术、新产品，使日本电子产品维持着很高的综合竞争力。<br><br>' +
					'优势院校：京都大学，東京工業大学，東京大学，横浜国立大学，九州大学，名古屋大学，大阪大学 <br><br> 就业前景：电子工程师以及工程主管',
				img:require('../../static/images/japan03.jpg')
			},
			{
				title:'计算机',
				content:'专业概况：日本的计算机公司在世界市场并不拥有很高的市场占有率，但是他们支配了本国市场，并且在美国及世界的超级计算机市场上成为IBM最强大的竞争对手，还向国际市场提供大量计算机部件。' +
					'计算机专业主要学习数据结构、操作系统、计算机网络、数据库系统、软件工程、人工智能等基础课程。<br><br>' +
					'优势院校：京都大学，東京工業大学，東北大学，横浜国立大学，九州大学，名古屋大学，大阪大学 <br><br>' +
					'就业前景：软件开发，网络安全与管理，编程，游戏动画设计',
				img:require('../../static/images/japan05.jpg')
			},
			{
				title:'动漫',
				content:'专业概况：就业率75%，日本是世界的动漫发源地，众多的动漫设计及游戏人物都在日本研发出来并享誉世界的。日本动漫在世界上处于领先地位，而中国动漫专业人才的缺口却与日俱增。日本拥有宫崎骏、宫崎吴郎父子等动漫大师，可以为动漫爱好者提供良好的学习环境。<br><br>' +
					'\n' +
					'优势院校：京都精华大学，東京藝術大学，东京工艺大学，大阪芸術大学<br><br>' +
					'\n' +
					'就业前景：网络动漫，网络游戏，手机游戏，手机动漫，传统的动画，漫画行业',
				img:require('../../static/images/japan06.jpg')
			},
			{
				title:'汽车',
				content:'专业概况：就业率高达95%，本田、日产、三菱、马自达等各种汽车工业都大批的招聘。日本汽车因其低油耗、质量好、外形美观等优点得到了世界各国的青睐。<br><br>' +
					'优势院校：东京工业大学，东北大学，九州大学，名古屋大学<br><br>' +
					'就业前景：汽车制造相关行业',
				img:require('../../static/images/japan07.jpg')
			},
			{
				title:'经济学',
				content:'专业概况：日本是一个资源匮乏的国家，近90%的资源都依靠进口。但是自二战后日本经济的复苏使得日本迅速跻身为世界第二大经济强国，日本企业更是遍布世界各个角落。随着中日之间的经济交流会日益增多，经济专业的就业前景变得十分广阔。<br><br>' +
					'优势院校：東京大学，京都大学，一橋大学，早稲田大学，大阪大学，九州大学，神戸大学，東北大学，横浜国立大学<br><br>' +
					'就业前景：经济预测分析人员，对外贸易人员，市场营销人员，管理类人员，以及银行，保险业相关人员.进入政府部门等',
				img:require('../../static/images/japan08.jpg')
			},
			{
				title:'机器人',
				content:'专业概况：就业率高达90%，SONY公司和EHIC机械工程公司常年招聘优秀人才。作为“机器人大国”，日本生产的机器人出口独占全球一半市场，其应用领域也逐渐从汽车、机械制造向宇航、救灾、海洋开发、家政、医疗福利以及娱乐等非制造业方向发展。<br><br>' +
					'\n' +
					'优势院校：東京工業大学，東北大学，名古屋大学，九州大学，北海道大学<br><br>' +
					'\n' +
					'就业前景：工业设计，设备维护，以及汽车机车类相关工作',
				img:require('../../static/images/japan09.jpg')
			},
			{
				title:'传媒',
				content:'专业概况：日本是一个大众传播媒介十分发达的国家，其各项指标不仅在亚洲处于遥遥领先的地位，就是在国际上也屈指可数。<br><br>' +
					'\n' +
					'优势院校：早稻田大学、筑波大学、同志社大学、上智大学、立教大学<br><br>' +
					'\n' +
					'就业前景：在新闻媒体机构（广播电台、电视台、网站、报社、杂志）、广告公司、从事编导、记者、主持、制作、广告与文化经济活动策划等',
				img:require('../../static/images/japan10.jpg')
			},
			{
				title:'服装设计',
				content:'专业概况：就业率高达70%，日本的三宅一生和各种服装设计品牌已经在亚洲甚至世界颇有名誉了。<br><br>' +
					'优势院校：京都工艺纺织大学、武藏野美术、东京艺术大学、东京造型大学、京都造型大学、文化女子大学<br><br>' +
					'就业前景：服装设计师，品牌策划师',
				img:require('../../static/images/japan11.jpg')
			},
			{
				title:'环境',
				content:'专业概况：近年来，日本非常重视环境治理，从制订完善法律和行政体系到广泛宣传教育，有效地扼制了环境的恶化.今天的日本，空气清新、环境优美、充分显示了环境保护工作的巨大成效。<br><br>' +
					'优势院校：名古屋大学、京都大学、东京海洋大学、东京农工大学、东京农业大学<br><br>' +
					'就业前景：政府的环境规划部门、环境资源咨询公司，或者到一些化学、制造、工程、采矿、石油等领域的公司中担任环境专业人员或工程师',
				img:require('../../static/images/japan12.jpg')
			},
			{
				title:'生物',
				content:'专业概况：生物技术主要应用于食品科学，制药科学等领域，日本的生物工程近一、二十年来发展极为神速。它成为影响未来国计民生的四大科学技术支柱，被认为是21世纪世界知识经济的核心。<br><br>' +
					'\n' +
					'优势院校：东京大学、京都大学、东北大学、九州大学、北海道大学、筑波大学、神户大学<br><br>' +
					'\n' +
					'就业前景：可到医疗卫生，医药，食品，化工，轻工，环境保护，生物工程产业部门，生物工程高科技公司及行政管理部门，从事生物工程及相关领域的应用研究，工程开发和管理工作',
				img:require('../../static/images/japan13.jpg')
			},
		]
	}
	render() {
		return (
			<div className={'page'}>
				<Header/>
				<div className={'main'}>
					<img className={'banimg'} src={require('../../static/images/japan01.jpg')} alt=""/>
					<div className={'content'}>
						<div className={'title'}>
							<span>日本简介</span>
							<span className={'line'}/>
						</div>
						<div className={'contentModule'}>
							<div className={'text textJust'}>
								日本国是位于亚洲大陆东岸外的太平洋岛国。西、北隔东海、日本海、鄂霍次克海与中国、朝鲜、韩国、俄罗斯相望，东濒太平洋。领土由北海道、本州、四国、九州四个大岛和3900多个小岛组成，日本属于发达国家，国民拥有很高的生活质量，
								人均国民生产总值超过四万美元稳居世界前列，是全球最富裕、经济最发达和生活水平最高的国家之一。
							</div>
							<img className={'img'} src={require('../../static/images/japan02.jpg')} alt=""/>
						</div>
						<div className={'title'}>
							<span>日本留学优势</span>
							<span className={'line'}/>
						</div>
						<div className={'textModule'}>
							{
								this.state.youshi.map((item,index)=>(
									<div className={'textModuleItem'} key={index}>
										<div className={'textModuleItemFlexWrap'}>
											<div className={'textModuleItemTitle'}>{item.name}</div>
											<div className={'textModuleItemText textJust'} dangerouslySetInnerHTML={{__html:item.content}}/>
										</div>
									</div>
								))
							}
						</div>
						<div className={'title'}>
							<span>日本留学热门专业</span>
							<span className={'line'}/>
						</div>
						<div className={'zhuanye'}>
							{
								this.state.zhuanye.map((item,index)=>(
									<CardItem item={item} key={index}/>
								))
							}
						</div>
					</div>
				</div>
				<Footer/>
			</div>
		)
	}
}

export default Japan